export enum SchemaTypes {
    Article = 'Article',
    ReadAction = 'ReadAction',
    WebSite = 'WebSite',
    Organization = 'Organization',
    VideoObject = 'VideoObject'
}

interface SchemaOrgThing {
    '@context'?: 'https://schema.org';
    '@type'?: string;
    '@id'?: string;
}

interface PotentialAction {
    '@type': SchemaTypes.ReadAction;
    target: string;
}

interface WebSite {
    '@type': SchemaTypes.WebSite;
    '@id': string;
    name: string;
    url: string;
}

interface Organization {
    '@type': SchemaTypes.Organization;
    name: string;
    url: string;
}

interface VideoObject {
    '@type': SchemaTypes.VideoObject;
    '@id'?: string;
    contentUrl?: string;
    name?: string;
    thumbnailUrl?: string;
    description?: string;
    uploadDate?: string;
}

export interface JsonLdData extends SchemaOrgThing {
    '@type': SchemaTypes;
    headline?: string;
    description?: string;
    image?: string[];
    datePublished?: string;
    dateModified?: string;
    inLanguage?: string;
    potentialAction?: PotentialAction;
    isPartOf?: WebSite;
    author?: Organization;
    hasPart?: VideoObject[];
}
